module.exports = ".aha-profile-panel-row {\n  border-bottom: 1px solid rgba(0, 0, 0, .175);\n}\n\n@media only screen and (min-width:767px){\n  .aha-profile-panel-row{\n    border-bottom: none;\n  }\n}\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/panels/aff-hospitals/aff-hospitals.component.css
// module id = ./src/app/profile/panels/aff-hospitals/aff-hospitals.component.css
// module chunks = main